import { EventEmitter } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, RouterStateSnapshot } from '@angular/router';

export class RecuperarSenhaGuard implements CanActivateChild {


    mostrarMenuEmitter = new EventEmitter<boolean>();

    constructor(
    ) {

    }
    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot) {

        if (state['url']  ===   '/recuperarSenha/esqueceuSenha') {
            localStorage.clear();
            this.mostrarMenuEmitter.emit(false)
            return false
        }
        return true;
    }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/guards/recuperarSenha.guard.ts